export function SearchIcon() {
  return (
    <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        d="M10.5356 10.5356L14 14M12 7C12 9.76142 9.76142 12 7 12C4.23858 12 2 9.76142 2 7C2 4.23858 4.23858 2 7 2C9.76142 2 12 4.23858 12 7Z"
        stroke={"currentColor"}
        strokeWidth="1.5"
      />
    </svg>
  );
}
